<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-dialog class="CustomersForm" :title="title" :visible.sync="editCustomersDialog" width="55%"
                    @click="closeDialog()">
                    <div>
                        <el-form :inline="true" :model="formInline" ref="formInline" class="user-search" size="small"
                            :rules="$rules">
                            <el-form-item label="企业名称：" prop="customersName">
                                <el-input size="small" v-model="formInline.customersName" placeholder="请输入企业名称">
                                </el-input>

                                <el-button type="primary" size="small" @click="editCustomer()">修改名称</el-button>

                            </el-form-item>

                            <el-form-item label="企业云ID：" prop="企业云ID">
                                <el-input size="small" v-model="formInline.customersID" disabled>
                                </el-input>
                            </el-form-item>


                            <el-form-item label="登录密码：" prop="loginPsw">
                                <el-input size="small" v-model="formInline.loginPsw" placeholder="请输入登录密码">
                                </el-input>

                                <el-button type="primary" size="small" @click="changePsw()">重置密码</el-button>

                            </el-form-item>


                            <el-form-item label="有效期：" prop="startDate">
                                <el-date-picker v-model="formInline.startDate" type="datetime" :clearable="false"
                                    placeholder="选择有效期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                                </el-date-picker>

                                <el-button type="primary" size="small" @click="changeDate()">过期设置</el-button>

                            </el-form-item>

                            <el-form-item label="错误登录次数：" prop="errorLogin">
                                <el-input size="small" v-model="formInline.errorLogin" placeholder="错误登录次数" disabled>
                                </el-input>

                                <el-button type="primary" size="small" @click="resetLogin()">重置次数</el-button>

                            </el-form-item>


                            <el-form-item label="" prop="QRCodeWeight" class="checkboxItem">
                                <el-checkbox v-model="formInline.QRCodeWeight" true-label="1"
                                    false-label="0">启用二维码过磅功能</el-checkbox>
                            </el-form-item>

                            <el-form-item label="" prop="appointmentWeight" class="checkboxItem">
                                <el-checkbox v-model="formInline.appointmentWeight" true-label="1"
                                    false-label="0">启用预约过磅功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="backendReview" class="checkboxItem">
                                <el-checkbox v-model="formInline.backendReview" true-label="1"
                                    false-label="0">启用预约后台审核功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="basicInformation" class="checkboxItem">
                                <el-checkbox v-model="formInline.basicInformation" true-label="1"
                                    false-label="0">启用云端基础信息修改功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="remoteRecharge" class="checkboxItem">
                                <el-checkbox v-model="formInline.remoteRecharge" true-label="1"
                                    false-label="0">启用远程充值功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="remoteModification" class="checkboxItem">
                                <el-checkbox v-model="formInline.remoteModification" true-label="1"
                                    false-label="0">启用远程修改数据功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="dataView" class="checkboxItem">
                                <el-checkbox v-model="formInline.dataView" true-label="1"
                                    false-label="0">启用集团版数据查看功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="WxApplyManage" class="checkboxItem">
                                <el-checkbox v-model="formInline.WxApplyManage" true-label="1"
                                    false-label="0">小程序预约自定义</el-checkbox>
                            </el-form-item>

                            <el-form-item class="checkboxItem">
                                <el-button type="primary" size="small" @click="changePermission()"
                                    style="margin-left: 80px;">修改权限</el-button>
                            </el-form-item>

                        </el-form>

                        <span slot="footer" class="dialog-footer">


                            <el-button type="delete" size="small" @click="deleteCustomer()">作废客户</el-button>

                            <el-button type="primary" size="small" @click="openCustomer()"
                                style="margin-right: 50px;">启用客户</el-button>

                            <el-button size="small" @click="closeDialog()" class="close">关 闭</el-button>

                        </span>

                    </div>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
// 导入请求方法
import { changeExpDate, changeCusName, changeCusPWD, resetErrorCount, changeCusRank, deleteCustomerItem, openCustomer } from "../../api/userMG";
export default {
    data() {
        return {
            editCustomersDialog: false,
            title: "",

            formInline: {
                customersName: "",
                customersID: "",
                loginPsw: "123",
                startDate: "",
                errorLogin: "0",
                QRCodeWeight: "0",
                appointmentWeight: "0",
                backendReview: "0",
                basicInformation: "0",
                remoteRecharge: "0",
                remoteModification: "0",
                dataView: "0",
                WxApplyManage: "0",
            },


            rowItem: [],
        };
    },
    methods: {
        isDialog(index, row, title) {
            let that = this;
            that.editCustomersDialog = index;
            that.title = title;
            that.rowItem = row;

            // 编辑赋值
            that.formInline = {
                customersName: row.企业名称,
                customersID: row.企业云ID,
                loginPsw: row.企业密码,
                startDate: row.过期时间,
                QRCodeWeight: row.启用二维码过磅 == 'True' ? '1' : '0',
                appointmentWeight: row.启用预约过磅 == 'True' ? '1' : '0',
                backendReview: row.启用预约审核 == 'True' ? '1' : '0',
                basicInformation: row.管理基础信息,
                remoteRecharge: row.管理远程充值,
                remoteModification: row.管理称重数据,
                dataView: row.集团管理,
                WxApplyManage: row.小程序预约自定义,
                errorLogin: row.错误登录次数 == '' ? 0 : row.错误登录次数,
            }

        },
        // 修改企业名称
        editCustomer() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "UID": that.rowItem.ID,
                "企业名称": that.formInline.customersName,
                "timeStamp": timestamp
            }

            changeCusName(params).then((res) => {
                if (res.data.code == 200) {
                    that.$message({
                        type: "success",
                        message: res.data.message,
                    });

                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })

        },

        // 修改密码
        changePsw() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "UID": that.rowItem.ID,
                "登录密码": that.formInline.loginPsw,
                "timeStamp": timestamp
            }

            changeCusPWD(params).then((res) => {
                if (res.data.code == 200) {
                    that.$message({
                        type: "success",
                        message: res.data.message,
                    });

                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })


        },

        // 修改有效期
        changeDate() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "UID": that.rowItem.ID,
                "有效期": that.formInline.startDate,
                "timeStamp": timestamp
            }

            changeExpDate(params).then((res) => {
                if (res.data.code == 200) {
                    that.$message({
                        type: "success",
                        message: res.data.message,
                    });

                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })
        },

        // 重置错误登录次数
        resetLogin() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "UID": that.rowItem.ID,
                "timeStamp": timestamp
            }
            resetErrorCount(params).then((res) => {
                if (res.data.code == 200) {
                    that.$message({
                        type: "success",
                        message: res.data.message,
                    });

                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })
        },

        // 修改权限
        changePermission() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "UID": that.rowItem.ID,
                "启用二维码过磅功能": that.formInline.QRCodeWeight,
                "启用预约过磅功能": that.formInline.appointmentWeight,
                "启用预约后台审核功能": that.formInline.backendReview,
                "启用云端基础信息修改功能": that.formInline.basicInformation,
                "启用远程充值功能": that.formInline.remoteRecharge,
                "启用远程修改数据功能": that.formInline.remoteModification,
                "启用集团版数据查看功能": that.formInline.dataView,
                "小程序预约自定义": that.formInline.WxApplyManage,
                "timeStamp": timestamp
            }

            changeCusRank(params).then((res) => {
                if (res.data.code == 200) {
                    that.$message({
                        type: "success",
                        message: res.data.message,
                    });

                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            })
        },

        // 作废客户
        deleteCustomer() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "UID": that.rowItem.ID,
                "企业云ID": that.rowItem.企业云ID,
                "timeStamp": timestamp,
            }

            that.$confirm('确定要作废客户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteCustomerItem(params).then((res) => {
                    if (res.data.code == 200) {
                        that.$message({
                            type: "success",
                            message: res.data.message,
                        });
                        that.$emit('reset', true);
                        that.closeDialog();

                    } else {
                        that.$message({
                            type: "error",
                            message: res.data.message,
                        });
                    }
                });
            }).catch(() => {

            });

        },

        // 启用客户
        openCustomer() {
            let that = this;

            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "UID": that.rowItem.ID,
                "企业云ID": that.rowItem.企业云ID,
                "timeStamp": timestamp,
            }

            that.$confirm('确定要启用客户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                openCustomer(params).then((res) => {
                    if (res.data.code == 200) {
                        that.$message({
                            type: "success",
                            message: res.data.message,
                        });
                        that.$emit('reset', true);
                        that.closeDialog();

                    } else {
                        that.$message({
                            type: "error",
                            message: res.data.message,
                        });
                    }
                });
            }).catch(() => {

            });

        },

        // 关闭编辑、增加弹出框
        closeDialog() {
            // this.$refs[formName].resetFields();
            this.$emit('reset', true);
            this.editCustomersDialog = false;
        },
    },
};
</script>
<style lang="less" scoped>
.el-form-item {
    width: 70%;
    margin: 7px 0;

    /deep/ .el-form-item__label {
        width: 120px;
    }

    /deep/ .el-form-item__content {
        width: 400px;

        .el-input--small {
            width: 250px;
        }

        .el-button--small {
            float: right;
        }

        .el-date-editor {
            width: 250px;

        }

    }
}

.checkboxItem {
    width: 31%;

    /deep/ .el-form-item__content {
        margin-left: 80px;
    }

    /deep/ .el-form-item__content {
        width: 100px;
    }

}


.dialog-footer {
    width: 100%;
    text-indent: 20px;
    overflow: hidden;
    margin: 10px 0;
    display: inline-block;

    .close{
        float: right;
        margin-right: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/admin666/editCustomers.vue